import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Heart } from 'lucide-react';

function UnionNodeComponent() {
  return (
    <>
      {/* Left handle for spouse 1 */}
      <Handle
        type="target"
        position={Position.Left}
        id="spouse1"
        className="!bg-transparent !border-0"
      />

      {/* Right handle for spouse 2 */}
      <Handle
        type="target"
        position={Position.Right}
        id="spouse2"
        className="!bg-transparent !border-0"
      />

      {/* The union heart */}
      <div className="w-5 h-5 flex items-center justify-center">
        <Heart className="w-4 h-4 text-bronze-500 fill-bronze-500" />
      </div>

      {/* Top handle (for connection from parent's union) */}
      <Handle
        type="target"
        position={Position.Top}
        id="parent"
        className="!bg-transparent !border-0"
      />

      {/* Bottom handle for children */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="children"
        className="!bg-transparent !border-0"
      />
    </>
  );
}

export const UnionNode = memo(UnionNodeComponent);
